<template>
  <div>
    <modal
      name="spotModal"
      :adaptive="true"
      :scrollable="true"
      delay="2000"
      width="1200"
      height="auto"
      style="z-index: 9999; text-align:center;"
      @closed="closeModal"
    >
      <div id="modalArea" v-if="work!=null">
        <section id="spotInfo">
          <h1>{{work.address}}</h1>
          <div class="spotLocation">
            <p class="photographer"><span>所有者: </span>{{work.photographer}}</p>
            <p class="taken_at"><span>撮影日: </span>{{work.takenAt}}</p>
            <p class="latlon"><span>経緯経度: </span>{{work.latitude}}, {{work.longitude}}</p>
          </div><!-- /info -->
        </section><!-- /spotInfo -->

        <section id="spotPhoto">
          <img :src="work.url" alt="北海道上川郡美瑛町字藤野の写真">
        </section><!-- /spotPhoto -->

        <section id="spotMap">
          <iframe :src="`https://maps.google.co.jp/maps?output=embed&z=15&q=${work.latitude},${work.longitude}`"></iframe>
        </section><!-- /spotMap -->

        <section id="spotDetails" v-if="work.spotInformations!=null && work.spotInformations.kankoKyokaiUrl!=null">
          <a target="_blank" :href="work.spotInformations.kankoKyokaiUrl"><img class="fade" src="/img/btn_biei-hokkaido-jp.png" srcset="/img/btn_biei-hokkaido-jp@2x.png 2x" alt="このスポットの詳細情報はこちら [美瑛町観光協会ウェブサイト]"></a>
        </section><!-- /spotDetails -->
      </div><!-- /modalArea -->
    </modal>
    <div class="closeModalBotton fade" v-if="open" style="z-index: 10000" @click="closeModal">
      <!-- <img class="fade" src="/img/btn_close.png" srcset="/img/btn_close@2x.png" @click="closeModal"> -->
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'work',
    'open'
  ],
  data () {
    return {
    }
  },
  methods: {
    closeModal () {
      this.$emit('update:open', false)
      this.$modal.hide('spotModal')
    }
  },
  watch: {
    open (val) {
      if (val) {
        this.$modal.show('spotModal')
      }
    }
  }
}
</script>

<style>
.vm--overlay {
  background: rgba(0, 0, 0, 0.8) !important;
}
.closeModalBotton {
  position: fixed;
  top: 20px;
  right: 40px;
  width: 83px;
  height: 83px;
  background: transparent url(/img/btn_close.png) 0 0px;
}
@media screen and (max-width:640px){
  .closeModalBotton {
    position: fixed;
    top: 5px;
    right: 5px;
    width: 32px;
    height: 32px;
    background: transparent url(/img/btn_close_sp.png) 0 0;
    background-size: contain;
  }
}
iframe {
  width: 100% !important;
  height: 100% !important;
  border: 0px !important;
}
</style>
